<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/salesTableFw',title:'销售样表（服务订单）'},{title:'销量样表（服务订单）编辑页面'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="f" label-position="right" ref="f" :inline="true"
                              class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>销售样表信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Bianjifw">
                                            <el-form-item label="产品编码" class="h-elformWrap-2">
                                                <el-input v-model="f.prodcode" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2">
                                                <el-input v-model="f.promodel" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品大类" class="h-elformWrap-2">
                                                <el-input v-model="f.prodseries" readonly></el-input>
                                            </el-form-item>


                                        <!--    <el-form-item label="状态" class="h-elformWrap-2">
                                                <brselect category="prodstatus" :v="f.prodstatus" v-model="f.prodstatus"/>
                                            </el-form-item>-->
                                            <el-form-item label="类型" class="h-elformWrap-2" prop="genre">
                                                <brselect category="sl_genre" v-model="f.genre" :v="f.genre"></brselect>
                                            </el-form-item>
                                            <el-form-item label="公司名称" class="h-elformWrap-2">
                                                <el-input v-model="f.companyname" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产地" class="h-elformWrap-2" prop="factory">
                                                <desselect category="factory" :des="this.factoryDict" :v="f.factory" disabled clearable v-model="f.factory"/>
                                            </el-form-item>
                                            <el-form-item label="是否有标准价" class="h-elformWrap-2" prop="havePrice">
                                                <brselect category="permit" v-model="f.havePrice" :v="f.havePrice"></brselect>
                                            </el-form-item>
                                            <el-form-item label="是否计入销额" class="h-elformWrap-2">
                                                <brselect  category="xiaoe_jishu" :v="f.xiaoe" v-model="f.xiaoe"></brselect>
                                            </el-form-item>
                                            <el-form-item label="是否计入基数" class="h-elformWrap-2">
                                                <brselect category="xiaoe_jishu" :v="f.jishu" v-model="f.jishu"></brselect>
                                            </el-form-item>
                                            <el-form-item label="链群" class="h-elformWrap-2">
                                                <brselectlazy category="xsyb_lianqun" v-model="f.lianqun"
                                                              :v="f.lianqun"></brselectlazy>
                                            </el-form-item>
                                            <el-form-item label="子链群" class="h-elformWrap-2" prop="lianqunchild">
                                                <brselectlazy category="xsyb_lianqunchild" v-model="f.lianqunchild"
                                                              :v="f.lianqunchild" :clearable="true"></brselectlazy>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="updatelist">确认修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>
	import ss from '../../api/SystemService'
	export default {
		data() {
			return {
					//带线表单
				f: {
				    factory:null,
				},
				loading: false,
                factoryDict:'1N60',
			}
		},
		created() {
			this.query();
		},
		methods: {
			query() {
				this.f.id = this.$route.query.id;
				ss.salesListFw.selectById(this.f.id).then(rd => {
					this.f = rd;
					this.f.companyname = this.$getDictName("xsyb_gongsi",this.f.companycode);
                    this.f.lianqunname = this.$getDictName("xsyb_lianqun",this.f.lianqun);
                    // this.f.factory = this.$getDictName("factory",this.f.factory)?this.f.factory:null;
				})
			},
			backS() {
				this.$router.push({path: "/chanp/salesTableFw"});
			},
			updatelist() {
				ss.salesListFw.updateById(this.f).then(rd => {
					this.$msg.msgs("操作成功");
					this.$router.push({path: "/chanp/salesTableFw"});
				})
			},

		}
	}
</script>

<style>
	.Bianjifw .el-form-item__label {
		width: 30%;
		text-align: right;
	}

	.Bianjifw .el-form-item__content {
		width: 70%;
	}

	.Bianjifw .h-elformWrap-2 {
		width: 33.333% !important;
		padding-right: 0.5rem
	}

	.Bianjifw .h-elformWrap-1 {
		width: 100%;
		padding-right: 0.5rem
	}
</style>
